module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerbar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "dropdown-button"
  }, [(_vm.user.pictureUrl) ? _c('img', {
    attrs: {
      "src": _vm.user.pictureUrl
    },
    on: {
      "click": _vm.toggleAccountMenu
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/anonymous.svg")
    },
    on: {
      "click": _vm.toggleAccountMenu
    }
  })]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('accountmenu', {
    attrs: {
      "user": _vm.user,
      "service": _vm.service
    },
    on: {
      "closeMenu": function($event) {
        _vm.closeMenu()
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "brand-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/logo-dialogloop-with-title.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41df6ce4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 470
// module chunks = 0